export enum FileSalesStatusEnum {
  None = 0,
  ForSale = 1,
  OnHold = 2,
}
